import { render, staticRenderFns } from "./AttendancePage.vue?vue&type=template&id=0cb2e8e6&scoped=true"
import script from "./AttendancePage.vue?vue&type=script&lang=js"
export * from "./AttendancePage.vue?vue&type=script&lang=js"
import style0 from "./AttendancePage.vue?vue&type=style&index=0&id=0cb2e8e6&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb2e8e6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0cb2e8e6')) {
      api.createRecord('0cb2e8e6', component.options)
    } else {
      api.reload('0cb2e8e6', component.options)
    }
    module.hot.accept("./AttendancePage.vue?vue&type=template&id=0cb2e8e6&scoped=true", function () {
      api.rerender('0cb2e8e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/attendance_v3/AttendancePage.vue"
export default component.exports